import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  return (
    <header role="banner">
      <nav className="navbar navbar-expand-lg navbar-light custom-navbar">
        <div className="container-fluid ps-2 pe-5">

          {/* Logo */}
          <Link to="/" className="navbar-brand d-flex p-0 m-0 flavours-nest-logo">
            <img src="/logo.png" alt="FlavoursNest Graphic" className="logo-img" />

            {/* <div className="d-flex flex-column">
              <h1 className="logo-title m-0">
                <span className="fw-bold text-dark-brown">Flavours</span>
                <span className="fw-semibold text-golden-tan">Nest</span>
               

              </h1>

              <p className="logo-subtitle m-0 text-uppercase fw-semibold">
                Your Cozy Home For Recipes
              </p>
            </div> */}
          </Link>

          {/* Mobile Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Nav Links */}
          <div className="collapse navbar-collapse" id="mainNavbar">
            <ul className="navbar-nav ms-auto align-items-lg-center">

              <li className="nav-item text-dark">
                <Link className="nav-link active" to="/">Home</Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/view-recipes">Recipes</Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/about">About</Link>
              </li>

              <li className="nav-item contact-btn ms-lg-3">
                <Link className="btn contact-btn" to="/contact">
                  Contact Us
                </Link>
              </li>

            </ul>
          </div>

        </div>
      </nav>
    </header>
  );
};

export default Navbar;